export const parseFloatOrNull = (input) => {
    const parsedValue = parseFloat(input);
    return isNaN(parsedValue) ? null : parsedValue;
}